import React, { useEffect, useState } from "react";
import PageLoader from "../loader/PageLoader";
import {
    ChatText,
    CurrencyInr,
    Key,
    Pencil,
    Trash,
    WarningCircle,
    WifiHigh,
    X,
} from "@phosphor-icons/react";
import axiosInstance from "../../api/axiosInstance";
import dayjs from "dayjs";
import { RejectHotel } from "./RejectAPI";
import {toast} from "react-toastify"
import { CompleteHotel } from './CompleteAPI';

const Wifi = ({ func, selectedRequest }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [remarks, setRemarks] = useState("");
    const [remarksError, setRemarksError] = useState(false);
    
    const [wifiList, setWifiList] = useState([]);
    const [wifi_name, setWifi_name] = useState("");
    const [wifi_password, setWifi_password] = useState("");
    const [editIndex, setEditIndex] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/wifi-request`,
                    { params: { guest_request_id: selectedRequest.requestId } },
                );

                setWifiList(response.data?.wifi_name_passwords);
                setData(response.data);
                setRemarks(response.data?.remarks || "");
                setLoading(false);
            } catch (err) {
                setErrors({ fetch: "Failed to fetch Extend Room data" });
                setLoading(false);
            }
        };
        fetchData();
    }, [selectedRequest]);

    const handleRejectRequest = async () => {
        try {
            if(remarks.trim()==="") {
                setRemarksError(true);
                return;
            }

            const request = {
                hotelId: selectedRequest.hotelId,
                bookingId: selectedRequest.bookingId,
                guestRequestId: data?.guest_request_id,
            };
            await RejectHotel(request,remarks);
            func(false);
        } catch (error) {
            setErrors({ reject: "Failed to reject the Extend room request" });
            console.error(error);
        }
    };

    // Function to handle adding/updating WiFi details
    const handleAddOrUpdate = () => {
        try{
            
            if (editIndex !== null) {
                // Update existing WiFi details
                const updatedList = wifiList.map((wifi, index) =>
                    index === editIndex ? { wifi_name, wifi_password } : wifi,
                );
                setWifiList(updatedList);
                setEditIndex(null); // Reset the edit index
            } else {
    
                if(wifi_name.trim()==="" || wifi_password.trim()==""){
                    toast.error("Both WiFi and Password must be provided");
                    return;
                }
    
                // Add new WiFi details
                setWifiList([...wifiList, { wifi_name, wifi_password }]);
            }
            // Clear input fields
            setWifi_name("");
            setWifi_password("");


        }catch(error){
            console.log(error);
        }
    };

    // Function to handle editing WiFi details
    const handleEdit = (index) => {
        setWifi_name(wifiList[index].wifi_name);
        setWifi_password(wifiList[index].wifi_password);
        setEditIndex(index); // Set the index of the item being edited
    };

    // Function to handle deleting WiFi details
    const handleDelete = (index) => {
        const updatedList = wifiList.filter((_, i) => i !== index);
        setWifiList(updatedList);
    };

    const handleRespondToGuest = async () => {
        try {
            // console.log("---------", {
            //     wifi_names_passwords: wifiList,
            //     remarks: remarks,
            // });

            if(wifiList.length === 0){
                toast.error("Please Enter Wifi Details");
                return;
            }
          
            await axiosInstance.put(
                `/api/v1/hotels/${selectedRequest.hotelId}/bookings/${selectedRequest.bookingId}/booked-rooms/${selectedRequest.bookedRoomId}/guest-requests/post-checkin/wifi-request/${data?.id}`,
                {
                    wifi_names_passwords: wifiList,
                    remarks: remarks,
                },
            );
 
            func(false);

        } catch (error) {
            setErrors({ fetch: "Failed to update Extend Room request" });
            console.error(error);
        }
    };

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            {loading && <PageLoader />}
            <form
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]"
                onSubmit={(e) => e.preventDefault()}
            >
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">WiFi</h2>
                    <button
                        onClick={() => func(false)}
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex items-center justify-between gap-2 mb-1">
                    <div className="w-1/4">
                        <p className="text-[#8C9199] mb-2">Room Number</p>
                        <p className="pr-4">{data?.service_room}</p>
                    </div>
                    <div className="w-3/4">
                        <p className="text-[#8C9199] mb-2">No. of devices</p>
                        <p className="pr-4">{data?.number_of_devices}</p>
                    </div>
                </div>
                <div>
                    <p className="mb-1 text-[#8C9199]">Note</p>
                    <p className="flex items-center gap-2 bg-yellow-100 p-1.5 rounded-md text-yellow-700 text-sm">
                        <ChatText size={16} weight="bold" />
                        {data?.additional_comments}
                    </p>
                </div>
                <div className="border-y-[1.5px] flex mt-2">
                    {/* Left section for displaying WiFi list */}
                    <div className="w-1/2 border-r-[1.5px] p-2">
                        <button
                            className="p-1.5 w-full bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150 outline-none text-xs"
                            type="button"
                            onClick={handleAddOrUpdate}
                        >
                            {editIndex !== null
                                ? "Update Wifi Details"
                                : "Add Wifi Details"}
                        </button>
                        <div className="py-2 h-[18vh] overflow-scroll flex flex-wrap gap-1">
                            <style jsx="true">{`
                                div::-webkit-scrollbar {
                                    display: none; /* For Chrome, Safari, and Opera */
                                }
                            `}</style>
                            {/* Map over wifiList to display each WiFi detail */}
                            {wifiList.map((wifi, index) => (
                                <div
                                    key={index}
                                    className="border-[1.5px] rounded-lg border-[#BFC4CC] bg-[#EEF0FB] flex flex-col px-2 py-1 justify-between w-[49%] gap-5"
                                >
                                    <div>
                                        <p className="font-bold text-[16px]">
                                            {wifi.wifi_name}
                                        </p>
                                        <p className="font-normal text-[#0A0D0C]">
                                            Password: {wifi.wifi_password}
                                        </p>
                                    </div>
                                    <div className="flex gap-1 justify-end">
                                        {/* Delete button */}
                                        <button
                                            className="rounded-md p-1 border-[1.5px] border-[#F5CCD3] h-[24px] w-[24px] bg-white"
                                            onClick={() => handleDelete(index)}
                                        >
                                            <Trash
                                                size={14}
                                                className="text-[#ff7378]"
                                            />
                                        </button>
                                        {/* Edit button */}
                                        <button
                                            className="rounded-md p-1 border-[1.5px] border-[#BFC4CC] h-[24px] w-[24px] bg-white"
                                            onClick={() => handleEdit(index)}
                                        >
                                            <Pencil size={14} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right section for WiFi input fields */}
                    <div className="w-1/2 flex flex-col gap-3 p-2">
                        <div>
                            <p>Wifi Name</p>
                            <div className="border-[1.5px] rounded-md p-1.5 w-full flex items-center gap-2 mt-1">
                                <WifiHigh />
                                <input
                                    type="text"
                                    placeholder="Enter wifi name"
                                    className="outline-none border-none w-full"
                                    value={wifi_name}
                                    onChange={(e) =>
                                        setWifi_name(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div>
                            <p>Wifi Password</p>
                            <div className="border-[1.5px] rounded-md p-1.5 w-full flex items-center gap-2 mt-1">
                                <Key />
                                <input
                                    type="text"
                                    placeholder="Enter password"
                                    className="outline-none border-none w-full"
                                    value={wifi_password}
                                    onChange={(e) =>
                                        setWifi_password(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <p className="text-[#8C9199] mb-1">Remarks</p>
                    <textarea
                        rows={4}
                        className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:border-blue-400"
                        placeholder="Mention your comment here"
                        value={remarks}
                        onChange={(e)=>{
                            const value = e.target.value;
                            setRemarks(value);
                            setRemarksError(false);
                        }}
                    ></textarea>
                    {remarksError && (
                        <p className="text-[#ff7378] flex gap-1 items-center text-xs mt-1">
                            <WarningCircle size={14} />
                            remarks is required when you reject the request
                        </p>
                    )}
                </div>

                <div className="grid grid-cols-2 gap-3 mt-2">
                    <button
                        className="p-2 w-full border-[1.5px] border-red-300 text-[#ff7378] rounded-md font-medium hover:bg-red-50 transition duration-150 outline-none"
                        type="button"
                        onClick={handleRejectRequest}
                    >
                        Reject Request
                    </button>
                    <button
                        className="p-2 w-full bg-[#ff7378] rounded-md font-medium hover:bg-[#f75f64] transition duration-150 outline-none"
                        type="button"
                        onClick={handleRespondToGuest}
                    >
                        Respond To Guest
                    </button>
                </div>

                {errors.fetch && <p className="text-red-500">{errors.fetch}</p>}
                {errors.reject && (
                    <p className="text-red-500">{errors.reject}</p>
                )}
            </form>
        </div>
    );
};

export default Wifi;
